/** @file 全站滚动入场动画初始化 */

(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new Set();
  const reveal = (element) => {
    element.classList.add('animated');
    if (observer) observer.unobserve(element);
    observed.delete(element);
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && observed.has(entry.target)) reveal(entry.target);
        });
      }, { rootMargin: '0px 0px -60px 0px' })
    : null;

  function elementsIn(root) {
    const elements = Array.from(root.querySelectorAll('.animate-js'));
    if (root.nodeType === 1 && root.matches('.animate-js')) elements.unshift(root);
    return elements;
  }

  function observeAnimations(root) {
    elementsIn(root).forEach((element) => {
      if (element.classList.contains('animated') || observed.has(element)) return;
      if (reducedMotion.matches || !observer || element.getBoundingClientRect().top < window.innerHeight - 60) {
        reveal(element);
      } else {
        observed.add(element);
        observer.observe(element);
      }
    });
  }

  function init() {
    observeAnimations(document);
    document.addEventListener('shopify:section:load', (event) => observeAnimations(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      elementsIn(event.target).forEach((element) => {
        if (observer) observer.unobserve(element);
        observed.delete(element);
      });
    });
    const onMotionChange = () => {
      if (reducedMotion.matches) Array.from(observed).forEach(reveal);
    };
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onMotionChange);
    else reducedMotion.addListener(onMotionChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
